module.exports = __webpack_public_path__ + "media/img/pole_b-46410d42.png";